export function interpolateNumber(from, to, ratio) {
    return from + (to - from) * ratio;
}
//# sourceMappingURL=number.js.map